import React, { useState } from "react";
import Image from "next/image";
import HireFromMilesForm from "@/components/forms/hireFromMilesForm";

const LongTermNursingTalentMobileHFM = () => {
  const [isformPopupOpen, setformPopupOpen] = useState(false);

  const openformPopup = () => {
    setformPopupOpen(true);
  };

  const closeformPopup = () => {
    setformPopupOpen(false);
  };
  return (
    <div className="flex flex-col gap-3 w-full bg-center square_grid_bg bg-repeat bg-[length:100% 100%]">
      <div className="text-center">
        <h2 className="font-semibold text-black text-[14px] text-center mt-7">
          <span className="leading-[normal]">
            Get Reliable, <br />{" "}
            <span className="text-[24px] border-[#CA7216] leading-[normal] border-b-[4px] pb-[5px]">
              Long-term Nursing Talent
            </span>
          </span>
        </h2>
      </div>

      <div className="w-full flex flex-col gap-20 mb-14">
        <div className="w-full flex flex-col justify-center items-center">
          <h3 className="text-black mt-8 text-[20px] font-bold leading-6">
            Hire Nurses in <span className="text-[#3174d6]">India</span>
          </h3>
          <div className="flex justify-center items-center">
            <Image
              loading="lazy"
              src="/hire-from-miles/nursing-in-india.png"
              alt="Hire Accountants in India"
              className="mr-20 mt-6"
              width={370}
              height={364}
            />
          </div>

          <div className="flex flex-col gap-3">
            <ul className="list-disc ml-8 w-[312px] text-black text-[16px] font-medium leading-6">
              <li>
                Solving your staffing needs quickly
                <br />
                with our flexible, specialized <br />
                healthcare workforce
              </li>
              <li>
                Fully trained & specialized, ensuring a<br />
                smooth integration to your hospital’s <br />
                standards
              </li>
              <li>
                Cost-effective staffing solutions <br />
                without sacrificing professional <br />
                standards
              </li>
            </ul>

            <div className="mt-8 w-full px-8">
              <div className="grp_btn flex items-center gap-2">
                <div className="know-more-arrow-container">
                  <Image
                    loading="lazy"
                    src="/hire-from-miles/know-more-arrow.svg"
                    alt=""
                    className="new_arrow mr-1"
                    width={14}
                    height={14}
                    quality={100}
                  />
                </div>
                <div
                  onClick={openformPopup}
                  className="know_more_btn_hireFromMiles w-full text-center text-[13px] font-semibold leading-9 cursor-pointer inline-block !px-10"
                >
                  Know More
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col justify-center items-center">
          <h3 className="text-black mt-8 text-[20px] font-bold leading-6">
            Hire USRNs in the <span className="text-[#FFBA08]">US.</span>
          </h3>
          <div className="flex justify-center items-center">
            <Image
              loading="lazy"
              src="/hire-from-miles/nursing-in-us.png"
              alt="US MD program for aspiring doctors in India"
              className=""
              width={345}
              height={404}
            />
          </div>
          <div className="flex flex-col gap-3">
            <ul className="list-disc ml-8 w-[312px] text-black text-[16px] font-medium leading-6">
              <li>
                Ready-to-deploy talent trained in the
                <br />
                US healthcare system
              </li>
              <li>
                Experienced international nurses with
                <br />
                unrestricted RN license
              </li>
              <li>
                3-year long-term contract with no
                <br />
                compliance or payroll hassles, <br />
                flat bill rate
              </li>
            </ul>
            <div className="mt-8 w-full px-8">
              <div className="grp_btn flex items-center gap-2">
                <div className="know-more-arrow-container">
                  <Image
                    loading="lazy"
                    src="/hire-from-miles/know-more-arrow.svg"
                    alt=""
                    className="new_arrow mr-1"
                    width={14}
                    height={14}
                    quality={100}
                  />
                </div>
                <a
                  href="https://www.milestalenthub.com/healthcare"
                  target="_blank"
                  className="know_more_btn_hireFromMiles w-full text-center text-[13px] font-semibold leading-9 cursor-pointer inline-block !px-10"
                >
                  Know More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isformPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div className="rounded-[14px] shadow-lg relative h-[auto] mx-auto w-[365px] bg-white p-4">
            <button
              onClick={closeformPopup}
              className="mt-4 text-[#878787] px-3 text-lg py-1 rounded absolute right-[10px] top-[16px] z-[9999]"
            >
              ✕
            </button>
            <HireFromMilesForm />
          </div>
        </div>
      )}
    </div>
  );
};

export default LongTermNursingTalentMobileHFM;
